import { CLEAR_INSTANCES, UPDATE_INSTANCES, SET_INSTANCE } from "../reducers/actiontypes";
import { fetchComments } from "./comments";
import { fetchLikes } from "./likes";
import { fetchStats } from "./stats";

export let clearInstances = function() {
	return {
		type: CLEAR_INSTANCES
	};
}

export let updateInstances = function(instances) {
	return {
		type: UPDATE_INSTANCES,
		instances: instances
	};
}

export let fetchInstances = function(action) {
	return function(dispatch, getState) {
		dispatch(clearInstances());

		window.getInstances(function(err, data){
			if (!err) {
				dispatch(updateInstances(data));
			}
		});
	};
};

export let setInstance = function(instance) {
	return {
		type: SET_INSTANCE,
		instance: instance
	};
}

export let loadInstance = function(instance) {
	return function(dispatch, getState) {
		var state = getState(),
			current_instance = state.instances.current,
			show_views = state.ui.show_views === true;

		dispatch(setInstance(instance));
		dispatch(fetchComments);
		dispatch(fetchLikes);
		if (show_views) {
			dispatch(fetchStats);
		}

		window.onInstanceChange(current_instance, instance);
	}
}